// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__3WY5R","detailsBorder":"styles_detailsBorder__1JUMO"};